export default {
    props: {
        plotAreaBackground: {
            type: String,
            kComposite: 'plotArea.background'
        }, 
        plotAreaOpacity: {
            type: Number,
            kComposite: 'plotArea.opacity'
        }, 
        plotAreaBorderColor: {
            type: String,
            kComposite: 'plotArea.border.color'
        }, 
        plotAreaBorderDashType: {
            type: String,
            kComposite: 'plotArea.border.dashType'
        }, 
        plotAreaBorderWidth: {
            type: Number,
            kComposite: 'plotArea.border.width'
        }, 
        plotAreaMargin: {
            type: Number | Object,
            kComposite: 'plotArea.margin'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/PlotArea.js